import {
  getRequest,
  postRequestByJson,
  getRequestOfExam,
  putRequest,
  deleteRequest,
  uploadFileRequest,
} from "@/libs/axios";
import { Message } from "element-ui";

function myThen(data) {
  if (data.result) {
    return Promise.resolve(data.data);
  } else {
    Message.error(data.failMsg);
    return Promise.reject(data.failMsg);
  }
}

export const uploadSign = (params = {}) => {
  return getRequestOfExam("/api/file/upload/parameter", params).then(myThen);
};
export const checkRepeat = (params = {}) => {
  return getRequestOfExam("/api/question/query/repeat", params).then(myThen);
};
export const getQuestionType = (params = {}) => {
  return getRequestOfExam("/api/question/query/group", params).then(myThen);
};

export const getQuestionBatchTemplate = (params = {}) => {
  return getRequestOfExam("/api/file/download/question", params).then(myThen);
};
export const appendQuestionType = (params = {}) => {
  return postRequestByJson("/api/question/create/group", params).then(myThen);
};
export const moveQuestionType = (params = {}) => {
  return postRequestByJson("/api/question/move/group", params).then(myThen);
};
export const deleteQuestionType = (params = {}) => {
  return postRequestByJson("/api/question/delete/group", params).then(myThen);
};
export const renameQuestionType = (params = {}) => {
  return postRequestByJson("/api/question/update/group", params).then(myThen);
};
export const createQuestion = (params = {}) => {
  return postRequestByJson("/api/question/create", params).then(myThen);
};
export const updateQuestion = (params = {}) => {
  return postRequestByJson("/api/question/update", params).then(myThen);
};
export const questionSearch = (params = {}) => {
  return postRequestByJson("/api/question/v1/pageQuery", params).then(myThen);
};
export const getQuestionDetail = (params = {}) => {
  return getRequestOfExam("/api/question/v2/query", params).then(myThen);
};
export const deleteQuestionList = (params = {}) => {
  return postRequestByJson("/api/question/delete", params).then(myThen);
};
export const moveQuestionGroup = (params = {}) => {
  return postRequestByJson("/api/question/move", params).then(myThen);
};
export const questionParse = (params = {}) => {
  return postRequestByJson("/api/question/parse", params).then(myThen);
};
export const batchCreate = (params = {}) => {
  return postRequestByJson("/api/question/batch/create", params).then(myThen);
};
export const getQuestionCount = (params = {}) => {
  return postRequestByJson("/api/question/group/random", params).then(myThen);
};
export const getRandomQuestion = (params = {}) => {
  return postRequestByJson("/api/question/random/extra", params).then(myThen);
};
export const getExaminationType = (params = {}) => {
  return getRequestOfExam("/api/question/query/group", params).then(myThen);
};
export const getLevelList = (params = {}) => {
  return getRequestOfExam("/api/question/getLevelList", params).then(myThen);
};
export const getQuestionTypeList = (params = {}) => {
  return getRequestOfExam("/api/question/getTypeList", params).then(myThen);
};
//分页查询试题导入记录列表
export const importQuestionList = (params = {}) => {
  return postRequestByJson("/api/question/v1/page/import-flow", params).then(
    myThen
  );
};
export const importQuestionDetailList = (params = {}) => {
  return postRequestByJson(
    "/api/question/v1/page/import-flow-detail",
    params
  ).then(myThen);
};
